import React, { useRef, useEffect, useState } from "react";
import styles from "./Canvas.module.css";
import SignaturePad from "react-signature-canvas";
import { useFormikContext } from "formik";
import Button from "../../Button/index";
import { useFormContext } from "../../../context/FormContext";

const Canvas = ({ field_label }) => {
  const { setFieldValue, values } = useFormikContext();
  const [signature, setSignature] = useState();
  const [trimmedDataURL, setTrimmedDataURL] = useState(null)
  const { sigPad } = useFormContext();

  const name = field_label;
 



  let data = sigPad;

  const save = () => {
    setSignature(data);
    setFieldValue(name, signature);
  };
  
  const clear = () => {
    sigPad.current?.clear();
  };



  useEffect(() => {
   
    if(!sigPad || !sigPad.current) return
    save();
  }, [sigPad.current]);

  return (
    <>
      <div className={styles.inputContainer}>
        <label className={styles.label}>{field_label}</label>
        <SignaturePad
          penColor="#1F1E52"
          canvasProps={{
            width: 360,
            height: 160,
            className: "sigCanvas" ,
            placeholder: 'Sign here',
            style: {
              borderRadius: '4px',
              border: '1px solid gray',
            }
          }}
          ref={sigPad}
        />
        {signature !== undefined && (
          <Button
            type="button"
            onClick={() => clear()}
            className={styles.secondaryButton}
          >
            Clear
          </Button>
        )}
       
      </div>
    </>
  );
};

export default Canvas;
